import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'
import kubun from 'config/kubun.json'

export const Seibetsu = props => {
  const options = kubun.seibetsu

  return <Dropdown.Standard options={options} {...props} />
}
